import type { CSVColumnDef, CSVHeader, CSVRow } from "./typings"

export interface CSVExporterConfig<TData> {
	columns: CSVColumnDef<TData>[]
	data: TData[]
}

export class CSVExporter<TData> {
	private columns: CSVColumnDef<TData>[]
	private data: TData[]

	constructor(config: CSVExporterConfig<TData>) {
		const { columns, data } = config

		this.columns = columns
		this.data = data
	}

	private unwrapHeader(header: CSVColumnDef<TData>["header"]): CSVHeader {
		return typeof header === "function" ? header() : header
	}

	getHeaders(): CSVHeader[] {
		return this.columns.map((col) => this.unwrapHeader(col.header))
	}

	getRows(): CSVRow[] {
		return this.data.map((row) => this.columns.map((col) => col.accessorFn(row)))
	}

	toPapaUnparseFormat(): { fields: string[]; data: CSVRow[] } {
		return {
			fields: this.getHeaders(),
			data: this.getRows(),
		}
	}
}

export function combineColumnDefs<TData>(...columnDefs: (CSVColumnDef<TData> | CSVColumnDef<TData>[])[]) {
	const ret: CSVColumnDef<TData>[] = []

	for (const column of columnDefs) {
		if (Array.isArray(column)) {
			for (const nested of column) {
				ret.push(nested)
			}
		} else {
			ret.push(column)
		}
	}

	return ret
}
